export const MAIN_CONTEXT = "Main_Context";
export const NEW_ORDER_CONTEXT = "New_Order_Context";
export const CUSTOMER_VIEW_CONTEXT = "Customer_View_Context";